export type Tile =
  | '-'
  | 'o'
  | 'e'
  | 'x'
  | 'l'
  | 's'
  | 'p'
  | 'g'
  | 'k'
  | 'd'
  | 'b'
  | 't'
  | 'w'
  | '~'
  | 'm'

export const TILE = {
  floor: '-',
  start: 'o',
  home: 'e',
  wall: 'x',
  lava: 'l',
  ice: 's',
  coin: 'p',
  gem: 'g',
  key: 'k',
  door: 'd',
  breakable: 'b',
  teleport: 't',
  switch: 'w',
  water: '~',
  shade: 'm',
} as const

export function isSolid(t: Tile): boolean {
  return t === 'x' || t === 'd' || t === 'b'
}

export function isHazard(t: Tile): boolean {
  return t === 'l' || t === '~' || t === 'm'
}

export function isCollectible(t: Tile): boolean {
  return t === 'p' || t === 'g'
}

export function isPassableFloor(t: Tile): boolean {
  return !isSolid(t)
}
